import React from 'react';
import 'bootstrap/js/dist/dropdown';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface IPageNavButtons {
	image?: IImage;
	link?: ILink;
}

export interface IPageNavProps extends IBaseElementProps {
	logo?: IImage;
	tagline?: string;
	ctas?: IPageNavButtons[];
	links?: IPageNavButtons[];
	featureLink?: ILink;
	children?: any;
}

/**
 * Page Nav
 * @block
 * @requiresHooks
 * @icon menu
 */

 const PageNav: React.FC<IPageNavProps> = ({
	className,
	logo,
	tagline,
	ctas,
	links,
	featureLink,
	children,
}) => (
	<div className={className || cn('page-nav', className)}>
		<div className="page-nav__sticky">
			<div className="page-nav__container">
				{logo && (
					<div className="page-nav__logo">
						<Image {...logo} alt={logo.alt} />
					</div>
				)}
				{tagline && (
					<h5 className="page-nav__tagline">
						{tagline}
					</h5>
				)}
				{ctas.length > 0 && (
					<ul
						className="page-nav__ctas">
						{ctas.map(
							(cta, index) => (
								<li key={index}>
									<a
										className="page-nav__ctas-link"
										href={cta.link.href}
									>
										<Image
											{...cta.image}
										/>
										{cta.link.label}
									</a>
								</li>
							),
						)}
						{featureLink && (
							<li>
								<a
									className="page-nav__ctas-link page-nav__ctas-link--feature"
									href={featureLink.href}
								>
									{featureLink.label}
								</a>
						</li>
						)}
					</ul>
				)}

				{links && (
					<div className="page-nav__nav">
							<Button
								className="page-nav__hamburger"
								onClick={(e) => {
									if ( e.target.parentElement?.classList.contains('open')) {
										e.target.parentElement?.classList.remove(
											'open',
										);
									} else {
										e.target.parentElement?.classList.add(
											'open',
										);
									}
								}}
								aria-label="Toggle dropdown"
							>
							</Button>
							<div className="page-nav__dropdown">
								<div>
									<ul className="page-nav__items page-nav__items--cta">
										{ctas.map((link, index) => (
											<li key={index} className="page-nav__item page-nav__item--cta">
												<a
													href={link.link?.href}
													className="page-nav__link"
												>
													<span>
														{link.link?.label}
													</span>
												</a>
											</li>
										))}
									</ul>
									<ul className="page-nav__items">
										{links.map((link, index) => (
											<li key={index} className="page-nav__item">
												<a
													href={link.link?.href}
													className="page-nav__link"
												>
													{link.image && (
														<Image
															className=""
															{...link.image}
														/>
													)}
													<span>
														{link.link?.label}
													</span>
												</a>
											</li>
										))}
										{featureLink && (
											<li className="page-nav__item page-nav__item--feature">
												<a
													href={featureLink.href}
													className="page-nav__link"
												>
													{featureLink.label}
												</a>
											</li>
										)}
									</ul>
								</div>
							</div>
					</div>
				)}
			</div>
		</div>
		{children}
	</div>
);

export default PageNav;
